import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Dipendente } from 'src/app/models/dipendente';
import { DipendenteChangeModel } from 'src/app/models/dipendente-change-model';
import { ImportDipendentiResult } from 'src/app/models/import-dipendenti-result';
import { Responsabile } from 'src/app/models/responsabile';
import { PrintBarCodeModel } from 'src/app/models/print-barcode-model';
import notify from 'devextreme/ui/notify';
@Injectable({
  providedIn: 'root',
})
export class DipendentiService {
  private http = inject(HttpClient);

  dipendentiUrl = environment.ildatoArticoliDpi + 'api/dipendenti';
  attivadisattivaUrl =
    environment.ildatoArticoliDpi + 'api/dipendenti/attivadisattiva';

  private _listDipendenti = new BehaviorSubject<Dipendente[] | undefined>(undefined);

  list(): Observable<Dipendente[]>{
    return this.http.get<Dipendente[]>(this.dipendentiUrl);
  }
  
  listTemp(forceRefresh: boolean = false): Observable<Dipendente[]> {
    if (
      this._listDipendenti.value == undefined ||
      forceRefresh
    ) {
      this.http.get<Dipendente[]>(this.dipendentiUrl).subscribe({
        next: (res) => {
          this._listDipendenti.next(res);
        },
        error: (err) => {
          if (err?.error?.title) {
            notify(err.error.title, 'error');
          } else {
            notify('Errore caricamento lista dipendenti', 'error');
          }
        },
      });
    }

    return this._listDipendenti.asObservable().pipe(filter((r) => r != null));
  }

  listResponsabili(): Observable<Responsabile[]> {
    return this.http.get<Responsabile[]>(this.dipendentiUrl + '/responsabili');
  }

  get(codCope: number): Observable<Dipendente> {
    return this.http.get<Dipendente>(this.dipendentiUrl + '/' + codCope);
  }

  post(values: DipendenteChangeModel): Observable<Dipendente> {
    return this.http.post<Dipendente>(`${this.dipendentiUrl}`, values);
  }

  update(key: number, values: DipendenteChangeModel): Observable<Dipendente> {
    return this.http.put<Dipendente>(`${this.dipendentiUrl}/${key}`, values);
  }

  remove(id: number): Observable<Dipendente> {
    return this.http.delete<Dipendente>(`${this.dipendentiUrl}/${id}`);
  }

  attivaDisattiva(
    id: number,
    attivo: boolean,
    values: Dipendente,
  ): Observable<Dipendente> {
    return this.http.put<Dipendente>(
      `${this.attivadisattivaUrl}/${id}/${attivo}`,
      values,
    );
  }

  downloadFileEsempio(): Observable<Blob> {
    return this.http.get(this.dipendentiUrl + '/getexampleimportfile', {
      responseType: 'blob',
    });
  }

  importDatiDipendentiXls(data: FormData): Observable<ImportDipendentiResult> {
    return this.http.post<ImportDipendentiResult>(
      this.dipendentiUrl + '/importadatidipendentixls',
      data,
    );
  }

  stampaEtichette(barCodeModel: PrintBarCodeModel): Observable<Blob> {
    return this.http.post(
      this.dipendentiUrl + '/stampeEtichette',
      barCodeModel,
      {
        responseType: 'blob',
      },
    );
  }

  cleanTemp(){
    this._listDipendenti.next(undefined);
  }
}
